import { useState } from "react";
import { Button } from "../../button";
import { Input } from "../../input";
import { Label } from "../../label";
import { Checkbox } from "../../checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../select";

export interface FileUploadContentProps {
  onSubmit: () => void;
}

export function FileUploadContent({ onSubmit }: FileUploadContentProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [profileField, setProfileField] = useState("");
  const [sendEmail, setSendEmail] = useState(false);
  const [dontShare, setDontShare] = useState(false);
  const [flagForReview, setFlagForReview] = useState(false);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleSubmit = () => {
    console.log("File upload submitted:", {
      file: selectedFile?.name,
      profileField,
      sendEmail,
      dontShare,
      flagForReview,
    });
    onSubmit();
  };

  return (
    <div className="flex-1 overflow-y-auto space-y-6 pr-2">
      {/* File Upload and Profile Field - Two Column Layout */}
      <div className="grid grid-cols-2 gap-4">
        {/* File Upload */}
        <div className="space-y-2">
          <Label htmlFor="file-upload" className="text-sm font-medium">
            Upload File
          </Label>
          <Input id="file-upload" type="file" onChange={handleFileChange} />
        </div>

        {/* Save to Custom Profile Field */}
        <div className="space-y-2">
          <Label htmlFor="profile-field" className="text-sm font-medium">
            Save to Custom Profile Field
          </Label>
          <Select value={profileField} onValueChange={setProfileField}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="No" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="medical-records">Medical Records</SelectItem>
              <SelectItem value="insurance-documents">Insurance Documents</SelectItem>
              <SelectItem value="lab-results">Lab Results</SelectItem>
              <SelectItem value="imaging">Imaging</SelectItem>
              <SelectItem value="prescriptions">Prescriptions</SelectItem>
              <SelectItem value="other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Selected File Info */}
      {selectedFile && (
        <p className="text-sm text-muted-foreground">
          Selected: {selectedFile.name} ({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)
        </p>
      )}

      {/* Checkboxes */}
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Checkbox id="send-email" checked={sendEmail} onCheckedChange={(checked) => setSendEmail(checked === true)} />
          <Label htmlFor="send-email" className="text-sm">
            Send email notification
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox id="dont-share" checked={dontShare} onCheckedChange={(checked) => setDontShare(checked === true)} />
          <Label htmlFor="dont-share" className="text-sm">
            Don't share in portal
          </Label>
        </div>

        <div className="flex items-center space-x-2">
          <Checkbox
            id="flag-review"
            checked={flagForReview}
            onCheckedChange={(checked) => setFlagForReview(checked === true)}
          />
          <Label htmlFor="flag-review" className="text-sm">
            Flag for review
          </Label>
        </div>
      </div>

      {/* Submit Button */}
      <div className="flex justify-end pt-4 border-t">
        <Button onClick={handleSubmit} className="w-full md:w-auto" disabled={!selectedFile}>
          Upload File
        </Button>
      </div>
    </div>
  );
}
